export default __webpack_public_path__ + "static/media/flashingarc7.9943b76c.png";